module.exports = __webpack_public_path__ + "media/images/shared/icon_pinterest-c32d4f4f42566bd04870b5054ac5040c.svg";